import { render, staticRenderFns } from "./labelList.vue?vue&type=template&id=1a5cf8be&scoped=true&"
import script from "./labelList.vue?vue&type=script&lang=js&"
export * from "./labelList.vue?vue&type=script&lang=js&"
import style0 from "./labelList.vue?vue&type=style&index=0&id=1a5cf8be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cf8be",
  null
  
)

component.options.__file = "labelList.vue"
export default component.exports